module.exports = __webpack_public_path__ + "img/IT.2089fcf0.svg";